export default "__VITE_ASSET__tCxp6SV0__"